import { render, staticRenderFns } from "./ListingModel.vue?vue&type=template&id=06f035e4&"
import script from "./ListingModel.vue?vue&type=script&lang=js&"
export * from "./ListingModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports